module.exports = __webpack_public_path__ + "static/media/bg2.5549f70a.jpg";